import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Box, Stack, IconButton, Tooltip, Typography, Chip } from '@mui/material';
import { MdiIcon } from '@components';
import { mdiChartLine, mdiPencil, mdiSync } from '@mdi/js';
import moment from 'moment';
/* edit: true -> mostra a linha das redes sociais, botão para editar Pessoa ou Empresa */
const editContactoCliente = ({ $state, pessoa, empresa, vendedor, edit, sendDatatoParent, handleShowChart, chartState, syncData }) => {
    //const entidade = pessoa || empresa;
    const [social, setSocial] = useState({});
    //const [block, setBlock] = useState(false);
    const [img, setImg] = useState('');
    const [name, setName] = useState('');
    useEffect(() => {
        if (pessoa?.redesSociais) {
            setSocial(JSON.parse(pessoa.redesSociais));
        }
        else if (empresa?.redesSociais) {
            setSocial(JSON.parse(empresa.redesSociais));
        }
        else {
            setSocial({});
        }
        if (pessoa !== undefined) {
            setSocial(JSON.parse(pessoa.redesSociais));
            setName(pessoa.nome);
            pessoa.userImage === null ? setImg('defaultAvatar.png') : setImg(pessoa.userImage);
        }
        if (empresa !== undefined) {
            setSocial(JSON.parse(empresa.redesSociais));
            setName(empresa.nome);
            empresa.imagem === null ? setImg('noImage.png') : setImg(empresa.imagem);
        }
        if (vendedor !== undefined) {
            setName(vendedor.Funcionario.name);
            vendedor.imagem === null ? setImg('defaultAvatar.png') : setImg(vendedor.imagem);
        }
    }, [pessoa, empresa, vendedor]);
    const isPessoa = !!pessoa; // boolean
    const isEmpresa = !!empresa; // boolean
    const isVendedor = !!vendedor; // boolean
    const EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    return (<Box>
      <Grid container spacing={2} justifyContent='flex-start' alignItems='center'>
        {!empresa && (<Grid item xs={12} sm={12} md={4} lg={2}>
            <Stack alignItems='center'>
              <Box component='img' src={img ? `/api/Upload/crm/download/${img}` : EMPTY_GIF} alt='Uploaded' sx={{
                maxWidth: '180px',
                maxHeight: '180px',
                width: 'auto',
                height: 'auto',
                borderRadius: isPessoa || isVendedor ? '50%' : '0'
            }}/>
            </Stack>
          </Grid>)}
        <Grid item xs={12} sm={12} md={8} lg={10}>
          <Grid container spacing={2}>
            {edit ? (<>
                <Grid item xs={11} sm={11} md={11} lg={10}>
                  <Typography variant='h5'>{name}</Typography>
                </Grid>
              </>) : (<>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant='h5'>{name}</Typography>
                </Grid>
              </>)}

            {isPessoa ? (
        // pessoa (coreContacto)
        <>
                {edit ? (<>
                    <Grid item xs={1} sm={1} md={1}>
                      <Stack justifyContent='flex-start' alignItems='center' direction='row'>
                        <Tooltip title={'Editar dados'} placement='top'>
                          <IconButton color='primary' onClick={() => $state.go('app.crm.pessoas.formEdit', { id: $state.params.id })}>
                            <MdiIcon path={mdiPencil} sx={{ color: '#1976D2' }}/>
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Grid>

                    {social ? (<Grid item xs={12} sm={12} md={12}>
                        <Stack direction='row' justifyContent='flex-start' spacing={2} sx={{ ml: -1 }}>
                          {social &&
                        Object.entries(social).map(([key, value]) => (<IconButton key={key} component='a' href={value} target='_blank' rel='noopener noreferrer'>
                                <Box component='img' src={`/images/crm_${key}.png`} alt={key} sx={{
                                maxWidth: '22px',
                                maxHeight: '22px',
                                width: 'auto',
                                height: 'auto'
                            }}/>
                              </IconButton>))}
                        </Stack>
                      </Grid>) : (<></>)}
                  </>) : (<></>)}

                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>Contacto Telefónico</Typography>
                  <Typography sx={{ color: 'black' }}>{pessoa.contactoTelefonico == null ? 'Desconhecido' : pessoa.contactoTelefonico}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>NIF</Typography>
                  <Typography sx={{ color: 'black' }}>{pessoa.nif == null ? 'Desconhecido' : pessoa.nif}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>Email</Typography>
                  <Typography sx={{ color: 'black' }}>{pessoa.email == null ? 'Desconhecido' : pessoa.email}</Typography>
                </Grid>

                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>Data de Nascimento</Typography>
                  <Typography sx={{ color: 'black' }}>{pessoa.dataNascimento == null ? 'Desconhecido' : moment(pessoa.dataNascimento).format('DD-MM-YYYY')}</Typography>
                </Grid>
                {/* <Grid item xs={6} sm={6} md={3}>
                  <Typography variant='caption'>Cargo</Typography>
                  <Typography sx={{ color: 'black' }}>{pessoa.cargo == null ? 'Desconhecido' : pessoa.cargo}</Typography>
                </Grid> */}
                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>Profissão</Typography>
                  <Typography sx={{ color: 'black' }}>{pessoa.profissao == null ? 'Desconhecido' : pessoa.profissao}</Typography>
                </Grid>
                {/* fecha a linha: as três classificações ficam juntas na linha seguinte */}
                <Grid item md={4} sx={{ display: { xs: 'none', md: 'block' } }}/>

                {[
                ['Serviços de interesse', pessoa.servicosInteresse],
                ['Departamentos', pessoa.departamentos],
                ['Áreas de formação', pessoa.areasFormacao]
            ].map(([label, valores]) => (<Grid item xs={6} sm={6} md={4} key={label}>
                    <Typography variant='caption'>{label}</Typography>
                    {valores?.length ? (<Stack direction='row' flexWrap='wrap' gap={0.5}>
                        {valores.map(v => (<Chip key={v.id} label={v.designacao} size='small'/>))}
                      </Stack>) : (<Typography sx={{ color: 'black' }}>Desconhecido</Typography>)}
                  </Grid>))}

                {edit ? (<>
                    {pessoa.interessesPessoais == null && pessoa.interessesProfissionais == null ? (<></>) : (<>
                        <Grid item xs={6} sm={6} md={12}>
                          <Typography variant='caption'>Interesses pessoais</Typography>
                          <Typography sx={{ color: 'black' }}>{pessoa.interessesPessoais == null ? 'Desconhecido' : pessoa.interessesPessoais}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={12}>
                          <Typography variant='caption'>Interesses profissionais</Typography>
                          <Typography sx={{ color: 'black' }}>{pessoa.interessesProfissionais == null ? 'Desconhecido' : pessoa.interessesProfissionais}</Typography>
                        </Grid>
                      </>)}
                  </>) : (<></>)}
              </>) : (<></>)}

            {isEmpresa ? (
        // empresa (coreCliente)
        <>
                {edit ? (<>
                    <Grid item xs={1} sm={1}>
                      <Stack justifyContent='flex-start' alignItems='center' direction='row' spacing={2}>
                        <Tooltip title={'Sincronizar com o Primavera'} placement='top'>
                          <IconButton color='primary' onClick={() => syncData()}>
                            <MdiIcon path={mdiSync} sx={{ color: '#1976D2' }}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={'Editar dados'} placement='top'>
                          <IconButton color='primary' onClick={() => $state.go('app.crm.empresas.formEdit', { id: $state.params.id })}>
                            <MdiIcon path={mdiPencil} sx={{ color: '#1976D2' }}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={!chartState ? 'Mostrar Indicadores' : 'Ocultar Indicadores'} placement='top'>
                          <IconButton onClick={() => handleShowChart()}>
                            <MdiIcon path={mdiChartLine} sx={{ color: '#0288d1' }}></MdiIcon>
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Grid>

                    {social ? (<Grid item xs={12} sm={12} md={12} lg={6}>
                        <Stack direction='row' justifyContent='flex-start' spacing={2} sx={{ ml: -1 }}>
                          {social &&
                        Object.entries(social).map(([key, value]) => (<IconButton key={key} component='a' href={value} target='_blank' rel='noopener noreferrer'>
                                <Box component='img' src={`/images/crm_${key}.png`} alt={key} sx={{
                                maxWidth: '22px',
                                maxHeight: '22px',
                                width: 'auto',
                                height: 'auto'
                            }}/>
                              </IconButton>))}
                        </Stack>
                      </Grid>) : (<></>)}

                    <Grid item xs={6} sm={6} md={6} lg={2}>
                      <Stack direction='row' sx={{ mr: 2 }} spacing={2} justifyContent='flex-start' alignItems='center'>
                        <Typography variant='body1'>Bloqueado</Typography>
                        {empresa.bloqueadoPrimavera == 1 ? <Chip label='Sim' color='error' size='small'/> : <Chip label='Não' color='success' size='small'/>}
                      </Stack>
                    </Grid>

                    {!social ? <Grid item xs={1} sm={1} md={1} lg={7}></Grid> : <></>}
                  </>) : (<></>)}

                <Grid item xs={12} sm={12} md={12}>
                  <Typography variant='caption'>Morada</Typography>
                  <Typography sx={{ color: 'black' }}>{!empresa.morada ? 'Desconhecido' : empresa.morada}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <Typography variant='caption'>Contacto</Typography>
                  <Typography sx={{ color: 'black' }}>{!empresa.contactoTelefonico ? 'Desconhecido' : empresa.contactoTelefonico}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <Typography variant='caption'>NIF</Typography>
                  <Typography sx={{ color: 'black' }}>{!empresa.nif ? 'Desconhecido' : empresa.nif}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>Email</Typography>
                  <Typography sx={{ color: 'black' }}>{!empresa.email ? 'Desconhecido' : empresa.email}</Typography>
                </Grid>

                <Grid item xs={6} sm={6} md={3}>
                  <Typography variant='caption'>Setor</Typography>
                  <Typography sx={{ color: 'black' }}>{empresa.crmSetor?.designacao ?? 'Desconhecido'}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <Typography variant='caption'>Condições de pagamento</Typography>
                  <Typography sx={{ color: 'black' }}>30 dias</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <Typography variant='caption'>CAE</Typography>
                  <Typography sx={{ color: 'black' }}>{!empresa.cae ? 'Desconhecido' : empresa.cae}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <Typography variant='caption'>Saldo Vencido</Typography>
                  <Typography sx={{ color: 'black' }}>{(empresa.saldo || 0).toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <Typography variant='caption'>Ref. Primavera</Typography>
                  <Typography sx={{ color: 'black' }}>{!empresa.refClientePrimavera ? 'Desconhecido' : empresa.refClientePrimavera}</Typography>
                </Grid>
              </>) : (<></>)}

            {isVendedor ? (<>
                <Grid item xs={1} sm={1} md={1}>
                  <Stack justifyContent='flex-start' alignItems='center' direction='row' spacing={2}>
                    <Tooltip title={'Editar dados'} placement='top'>
                      <IconButton color='primary' onClick={() => sendDatatoParent(true)}>
                        <MdiIcon path={mdiPencil} sx={{ color: '#1976D2' }}/>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={!chartState ? 'Mostrar Indicadores' : 'Ocultar Indicadores'} placement='top'>
                      <IconButton onClick={() => handleShowChart()}>
                        <MdiIcon path={mdiChartLine} sx={{ color: '#0288d1' }}></MdiIcon>
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={9.5}>
                  <Grid container justifyContent='flex-start' alignItems='center' sx={{ height: '100%' }} spacing={2}>
                    <Grid item xs={6} sm={6} md={3}>
                      <Typography variant='caption'>Contacto</Typography>
                      <Typography sx={{ color: 'black' }}>{vendedor.Funcionario.telemovel ?? 'Não tem'}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3}>
                      <Typography variant='caption'>Email</Typography>
                      <Typography sx={{ color: 'black' }}>{vendedor.Funcionario.email}</Typography>
                    </Grid>
                    <Grid item md={6}></Grid>
                  </Grid>
                </Grid>
              </>) : (<></>)}
          </Grid>
        </Grid>
      </Grid>
    </Box>);
};
export default editContactoCliente;
